import React from 'react'
import { TextSlice } from './slice/text.slice'

interface Slice {
  slice_type: string,
  items: any[]
  primary: any
}

interface Props {
  data: Slice[]
}

const slices: { [key: string]: any } = {
  text: TextSlice,
  image_text: null,
  image_list: null,
  text_blocks: null,
  hero_banner: null,
  cta: null,
}

export const PrismicBody: React.FC<Props> = (props) => {
  if (!props.data) {
    return null
  }

  console.log(props.data)

  return (
    <>
      {props.data.map((slice, index) => {
        const Component = slices[slice.slice_type]

        if (!Component) {
          return null
        }

        return (
          <Component
            key={index}
            primary={slice.primary}
            items={slice.items}
          />
        )
      })}
    </>
  )
}
